var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJackpotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9 20.4H34.4l-1.6-1.6a4 4 0 0 1-.5-.5l-7.6-11c-2-3 .6-7 4.1-6.2l6.8 1.5 9.6 2.3A4 4 0 0 0 47 5l9.6-2.3L63.4 1a4 4 0 0 1 4.2 6.2l-7.6 11a4 4 0 0 1-.5.5l-1.6 1.6Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.6 41.8 13.5-15.2H60l13.5 15.2 9 13 1 1.7 5.4 12.3c.5 1 .8 2.3.9 3.5l.3 6.3c0 1 0 2-.3 2.8l-1.2 5.1a10 10 0 0 1-3 5.1l-3.3 2.9a10 10 0 0 1-6.6 2.5H14.4a10 10 0 0 1-6.6-2.5l-3.2-2.9a10 10 0 0 1-3.1-5.1l-1.2-5a10 10 0 0 1-.3-3l.3-6.2c.1-1.2.4-2.4.9-3.5l5.4-12.3 1-1.7 9-13Zm18.6 32.9c1.7 1.6 4.2 2.7 7.6 3.1v5.4c0 .4.2.8.4 1 .3.4.6.5 1 .5h2.3c.4 0 .7-.1 1-.4.2-.3.4-.6.4-1v-5.6c2.2-.5 4-1.5 5.5-3.1a9 9 0 0 0-.7-12.8 21.1 21.1 0 0 0-6.2-3.6l-2-.9a12 12 0 0 1-1.9-1 6 6 0 0 1-1.3-1.4 3 3 0 0 1-.6-1.8c0-.6.1-1.2.4-1.7.7-1.3 2-2 4.2-2 2.3 0 4.4.7 6.4 2.2l.8.3c.5 0 1-.6 1.7-1.9.4-.8.6-1.5.6-2 0-.2-.1-.5-.4-.7l-1-.8a14 14 0 0 0-5.3-2V39c0-.4-.1-.8-.4-1.1-.2-.3-.5-.4-.9-.4h-2.4c-.3 0-.7.1-1 .4-.2.3-.3.7-.3 1v5.6c-2.3.4-4.1 1.4-5.5 2.8a7.8 7.8 0 0 0-2.4 5.7 9 9 0 0 0 2.8 6.6c.8.8 1.8 1.5 2.8 2.2l3 1.4 2.6 1c2.6 1.2 4 2.7 4 4.4 0 1.4-.5 2.4-1.5 3.2a5 5 0 0 1-1.6.8c-.7.2-1.6.2-2.8.2-1.1 0-2.4-.3-3.8-1l-1.8-.9c-.6-.4-1.2-.6-1.8-.6-.5 0-1 .3-1.2.9l-.8 1.6-.3 1.1c0 .3.1.5.4.8Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 46.1,
    y1: 1,
    x2: 46.1,
    y2: 20.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29D28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 45,
    y1: 26.6,
    x2: 45,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D29D28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotIcon);
export default __webpack_public_path__ + "static/media/jackpot-icon.9a9e93174f96fd93f189908235efe05f.svg";
export { ForwardRef as ReactComponent };